import { render, staticRenderFns } from "./OrdersInboundModule.vue?vue&type=template&id=7b06dc7d"
import script from "./OrdersInboundModule.vue?vue&type=script&lang=js"
export * from "./OrdersInboundModule.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports